export const USER_TYPES = {
  EXECUTIVE_PRODUCER: ['OWNER', 'PRIVILEGED STAFF'],
  PRODUCER: ['OWNER', 'PRIVILEGED STAFF', 'COMMON STAFF'],
  CONTRACTOR: ['CONTRACTOR'],
  AGENCY: [],
  BRAND: [],
  NO_RELATION: 'NO RELATION'
};
